import React from 'react'
import {Signboard} from '../../../DTO/SignboardDTO'
import {PIMCard} from '../../Atoms/Cards/PIMCard'
import {MBContentBodyItemWarningMessageTypography, MBContentNoteWithMarkTypography, MBContentSubTitleTypography} from '../../Atoms/Typographies'
import {Spacer} from '../../../../Common/Components/Spacer'
import {BorderedContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {BucketMemberId} from '../../../DTO/BucketMemberId'
import BucketHeader from '../../../DTO/BucketHeader'
import {RegisterOrganizationContentBlockProps} from './RegisterOrganizationContentBlock'
import {SignedUpServiceListContent} from './SignedUpServiceListContent'
import {getSignupFreeBucketList} from './RegisteredFreeServiceContentBlock'
import {useTranslation} from 'react-i18next'

type RegisteredOrganizationContentBlockProps =
  Pick<RegisterOrganizationContentBlockProps, 'signboard' | 'title'> & {
  bucketMemberIdList: BucketMemberId[]
  isCvsPayment?: boolean
}

export const RegisteredOrganizationContentBlock:
  React.VFC<RegisteredOrganizationContentBlockProps> = (
  {
    signboard,
    title,
    bucketMemberIdList,
    isCvsPayment,
  },
) => {
  return (
    <PIMCard
      headerProps={{title: title, logoUrl: signboard.logoImgUrl}}
      testId={'block-registered-organization'}
      pb={'24px'}
    >
      <SignedUpServiceListContent
        signedUpBucketHeaderList={[signboard.mainService]}
        bucketMemberIdList={bucketMemberIdList}
        testId={'block-registered-organization-main-service'}
      />
      <CvsPaymentBlock signboard={signboard} isCvsPayment={isCvsPayment}/>
      <FreeBucketsBlock
        freeServices={signboard.freeServices}
        bucketMemberIdList={bucketMemberIdList}
        isCvsPayment={isCvsPayment}
      />
    </PIMCard>
  )
}

type CvsPaymentBlockProps = {
  signboard: Signboard,
  isCvsPayment?: boolean
}

const CvsPaymentBlock: React.VFC<CvsPaymentBlockProps> = (
  props,
) => {
  const {signboard, isCvsPayment = false} = props

  return isCvsPayment ? (
    <Spacer mt={'10px'}>
      <MBContentBodyItemWarningMessageTypography>
        コンビニ店頭で年会費をお支払い完了後、{signboard.mainService.name}への入会が完了します。
      </MBContentBodyItemWarningMessageTypography>
      <Spacer mt={'10px'}>
        <MBContentNoteWithMarkTypography note={'決済確認には最大1日程度お時間がかかる場合があります。'}/>
      </Spacer>
    </Spacer>
  ) : null
}

type FreeBucketsBlockProps = {
  freeServices: BucketHeader[],
  bucketMemberIdList: BucketMemberId[]
  isCvsPayment?: boolean
}
const FreeBucketsBlock: React.VFC<FreeBucketsBlockProps> = (
  {
    freeServices,
    bucketMemberIdList,
    isCvsPayment,
  },
) => {
  const {t} = useTranslation('member')

  if (freeServices.length === 0 || bucketMemberIdList.length === 0 || isCvsPayment) return null

  const signupFreeBucketList = getSignupFreeBucketList(freeServices, bucketMemberIdList)

  if (signupFreeBucketList.length === 0) return null

  return <Spacer mt={'24px'}>
    <BorderedContentBlock data-testid={'block-registered-organization-free-services'}>
      <PIMStack spacing={2}>
        <MBContentSubTitleTypography>
          {t('新規登録情報確認.入会バケット情報.無料付帯バケット.見出し')}
        </MBContentSubTitleTypography>
        <SignedUpServiceListContent
          signedUpBucketHeaderList={signupFreeBucketList}
          bucketMemberIdList={bucketMemberIdList}
        />
      </PIMStack>
    </BorderedContentBlock>
  </Spacer>
}
